import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { updateStatus } from 'redux/actions';
import { Status } from 'apis/Status';
import './HeatmapRetrieveErrorScreen.css';

const ERROR_MESSAGE =
  'To re-attempt the Retrieve, please select “Retrieve Heatmap” below.  If the problem persists, please contact Customer Service.';

const ERROR_MESSAGE_DUPLICATE =
  'Failed to save the duplicate heatmap, please select “Retry” below. If the problem persists, please contact Customer Service.';

const HeatmapRetrieveErrorScreen = (props) => {
  const [cancelRequest, setCancelRequest] = useState(true);
  const dispatch = useDispatch();
  let errorCodeMessage = `NOT COMPLETED: The error code is ${
    props.saveDuplicateErrorCode ? props.saveDuplicateErrorCode : props.errorCode
  }.`;

  let errorMessage = props.saveDuplicateErrorCode ? ERROR_MESSAGE_DUPLICATE : ERROR_MESSAGE;

  useEffect(() => {
    if (cancelRequest) {
      setCancelRequest((prevVal) => {
        dispatch(updateStatus(props.getLatestHeatmapFromDeviceStatusName, Status.NONE));
        props.cancelRequest();
        props.clearTimeoutAndInterval();
        return false;
      });
    }
  }, []);

  return (
    <div id="HeatmapRetrieveErrorScreen_Container" className="HeatmapRetrieveErrorScreen_Container">
      <div id="HeatmapRetrieveErrorScreen_TopContainer" className="HeatmapRetrieveErrorScreen_TopContainer">
        <div id="HeatmapRetrieveErrorScreen_HeaderText" className={'HeatmapRetrieveErrorScreen_HeaderText'}>
          Error
        </div>
        <div
          id="HeatmapRetrieveErrorScreen_MessageText"
          className="HeatmapRetrieveErrorScreen_MessageText"
          data-tip={errorCodeMessage}
        >
          {errorCodeMessage}
        </div>
        <div
          id="HeatmapRetrieveErrorScreen_MessageText"
          className="HeatmapRetrieveErrorScreen_MessageText"
          data-tip={errorMessage}
        >
          {errorMessage}
        </div>
      </div>
      <div id="HeatmapRetrieveErrorScreen_BottomContainer" className="HeatmapRetrieveErrorScreen_BottomContainer">
        <button
          type="submit"
          disabled={false}
          id="HeatmapRetrieveErrorScreen_Bottom_ActionButton"
          className={classnames({
            HeatmapRetrieveErrorScreen_Bottom_ActionButton: true,
            HeatmapRetrieveErrorScreen_Bottom_ActionButton_Disabled: false
          })}
          onClick={() => {
            // props.retrieveHeatmapAction(true);
            props.setIsRetrieveBtnTriggered(true);
            props.clearTimeoutAndInterval();
            props.resetStates();
          }}
        >
          {!props.saveDuplicateErrorCode ? 'Retrieve Heatmap' : 'Retry'}
        </button>
        <button
          id="HeatmapRetrieveErrorScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapRetrieveErrorScreen_Bottom_CancelButton: true
            // HeatmapRetrieveErrorScreen_Bottom_CancelButton_Disabled: isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapRetrieveErrorScreen);
